export const ItemReviews = (props) => {
    const itemReviews = props.itemReviews;

    return (
        <>
            <div id="listing-reviews" class="listing-section">
                <h3 class="listing-desc-headline margin-top-25 margin-bottom-20">Reviews <span>({itemReviews.totalReviews}) - {itemReviews.score} de 5.0</span></h3>
                {/* TODO: Falta estilo de estrellas */}
                <div class="clearfix"></div>

                {/* <!-- Reviews --> */}
                <section class="comments listing-reviews">
                    <ul>
                        {!!itemReviews.reviews && itemReviews.reviews.map((review) => (
                            <>
                                <li>
                                    <div class="avatar"><img src={review.avatar} alt="" /></div>
                                    <div class="comment-content"><div class="arrow-comment"></div>
                                        <div class="comment-by">{review.userName} <i class="tip" data-tip-content="Person who left this review actually was a customer"></i> <span class="date">{review.date}</span>
                                            <div class="star-rating" data-rating="5"></div>
                                        </div>
                                        <p>{review.comment}</p>

                                        {review.images && (
                                            <div class="review-images mfp-gallery-container">
                                                {review.images.map((image) => (
                                                    <>
                                                        <a href={image} target="_blank" class="mfp-gallery"><img src={image} alt="" /></a>
                                                    </>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </li>
                            </>
                        ))}
                    </ul>
                </section>
            </div>
        </>
    )
}